import React from "react";
import AdminDashboardInstance from "./AdminDashboard/AdminDashboardInstance";

export default props => <AdminDashboardInstance {...props} />;
